import React, { useEffect, useRef, useState } from "react";
import { SketchPicker } from "react-color";
import { Box, Button, Typography } from "@mui/material";
import { companyService } from "../../app/services";
import { useTranslation } from "react-i18next";

const WebsiteEditorPage = ({ companyUsername }) => {
  const { t } = useTranslation();
  const iframeRef = useRef(null);
  const [iframeHtml, setIframeHtml] = useState("");
  const [company, setCompany] = useState(null);
  const [companyServices, setCompanyServices] = useState([]);
  const [companyEmployees, setCompanyEmployees] = useState([]);
  const [primaryColor, setPrimaryColor] = useState("#8d0c2f");

  // fetch company & template
  useEffect(() => {
    if (!companyUsername) return;

     companyService.getCompaniesByCategoryAndLocationAndCompanyid("", {}, companyUsername).then((res) => {
      setCompany(res[0]);
      setIframeHtml(res[0].pagehtml); // load saved template
    });

    companyService
      .getCompanyServicesByParameterNotConnected(companyUsername, "")
       .then(response => {

        const translatedServices = response.map(service => ({
          ...service,
          name: t(service.name) // apply your i18n translation
        }));

        setCompanyServices(translatedServices);
        console.log("Services");
        console.log(response);
        return true;
      });

    companyService
      .getCompanyEmployeesNotConnected(companyUsername)
      .then((res) => setCompanyEmployees(res.data));
  }, [companyUsername]);

  // inject HTML and fill with company data
  useEffect(() => {
    if (!iframeHtml || !iframeRef.current || !company) return;

    const iframe = iframeRef.current;
    const doc = iframe.contentDocument || iframe.contentWindow.document;

    doc.open();
    doc.write(iframeHtml);
    doc.close();

    iframe.onload = () => {
      const win = iframe.contentWindow;
      if (!win) return;
      win.postMessage(
        {
          type: "INIT_DATA",
          company,
          companyServices,
          companyEmployees,
          translations: {
            translations: {
                services_available: t('BookingWidget.ServicesAvailable'),
                choose_mechanic: t('BookingWidget.ChooseMechanic'),
                summary: t('BookingWidget.Summary'),
                selected_services: t('BookingWidget.SelectedServices'),
                mechanic: t('BookingWidget.Mechanic'),
                none: t('BookingWidget.None'),
                total: t('BookingWidget.Total'),
                book_now: t('BookingWidget.BookNow'),
              }
          }
        },
        "*"
      );
    };
  }, [iframeHtml, company, companyServices, companyEmployees]);

  // live update header color
  const handleColorChange = (color) => {
    setPrimaryColor(color.hex);

    const iframe = iframeRef.current;
    const doc = iframe?.contentDocument || iframe?.contentWindow?.document;
    if (!doc) return;

    const header = doc.querySelector(".header");
    if (header) {
      header.style.background = color.hex;
    }
  };

  // replace logo
  const handleLogoUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      const iframe = iframeRef.current;
      const doc = iframe?.contentDocument || iframe?.contentWindow?.document;
      if (!doc) return;

      const logoEl = doc.getElementById("professionalLogo");
      if (logoEl) logoEl.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };

  // save final HTML into DB
  const handlePublish = async () => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const doc = iframe.contentDocument || iframe.contentWindow.document;
    if (!doc) return;

    const finalHtml = "<!DOCTYPE html>\n" + doc.documentElement.outerHTML;

    await companyService.updateCompanyPageHtml(company, finalHtml);
    alert("Website published successfully!");
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {/* Sidebar Controls */}
      <Box
        sx={{
          width: 300,
          borderRight: "1px solid #ddd",
          padding: 2,
          overflowY: "auto",
        }}
      >
        <Typography variant="h6">Website Editor</Typography>

        <Typography sx={{ mt: 2 }}>Header Color</Typography>
        <SketchPicker color={primaryColor} onChange={handleColorChange} />

        <Typography sx={{ mt: 2 }}>Logo</Typography>
        <input type="file" accept="image/*" onChange={handleLogoUpload} />

        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3, width: "100%" }}
          onClick={handlePublish}
        >
          Publish
        </Button>
      </Box>

      {/* Live Preview */}
      <Box sx={{ flex: 1 }}>
        <iframe
          ref={iframeRef}
          style={{ width: "100%", height: "100%", border: "none" }}
          title="Website Preview"
        />
      </Box>
    </Box>
  );
};

export default WebsiteEditorPage;


// import React, { useState, useRef, useEffect } from "react";
// import { SketchPicker } from "react-color";
// import { companyService } from "../../app/services";

// export default function WebsiteEditor({ company }) {
//   const iframeRef = useRef(null);
//   const [templateHtml, setTemplateHtml] = useState("");
//   const [settings, setSettings] = useState({
//     primaryColor: "#8d0c2f",
//     secondaryColor: "#2563eb",
//     buttonHoverColor: "#c2185b",
//     textColor: "#333",
//     logo: "",
//   });

//   // Load base template from backend
//   useEffect(() => {
//           companyService.getCompaniesByCategoryAndLocationAndCompanyid("", {}, company)
//         .then(response => {
//           debugger;
//           setTemplateHtml(response[0].pagehtml)
//           return true;
//         });
//   }, [company]);

//   // Apply customization in iframe
//   const applySettings = () => {
//     const iframe = iframeRef.current;
//     if (!iframe) return;
//     const doc = iframe.contentDocument || iframe.contentWindow.document;

//     // Inject CSS variables
//     const style = `
//       :root {
//         --primary-color: ${settings.primaryColor};
//         --secondary-color: ${settings.secondaryColor};
//         --button-hover-color: ${settings.buttonHoverColor};
//         --text-color: ${settings.textColor};
//       }
//     `;
//     let styleTag = doc.getElementById("custom-style");
//     if (!styleTag) {
//       styleTag = doc.createElement("style");
//       styleTag.id = "custom-style";
//       doc.head.appendChild(styleTag);
//     }
//     styleTag.innerHTML = style;

//     // Update logo
//     if (settings.logo) {
//       const logoEl = doc.getElementById("professionalLogo");
//       if (logoEl) logoEl.src = settings.logo;
//     }
//   };

//   const handleColorChange = (field, color) => {
//     setSettings((prev) => ({ ...prev, [field]: color.hex }));
//   };

//   const handleLogoUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = (event) => {
//       setSettings((prev) => ({ ...prev, logo: event.target.result }));
//     };
//     reader.readAsDataURL(file);
//   };

//   const handlePublish = async () => {
//     const iframe = iframeRef.current;
//     if (!iframe) return;
//     const doc = iframe.contentDocument || iframe.contentWindow.document;
//     const finalHtml = doc.documentElement.outerHTML;

//     await fetch(`/api/company/${company}/publish`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ html: finalHtml }),
//     });
//     alert("Website published!");
//   };

//   return (
//     <div style={{ display: "flex", gap: "20px" }}>
//       {/* Customization Panel */}
//       <div style={{ width: "300px" }}>
//         <h3>Customize Website</h3>

//         <p>Primary Color</p>
//         <SketchPicker
//           color={settings.primaryColor}
//           onChange={(c) => handleColorChange("primaryColor", c)}
//         />

//         <p>Secondary Color</p>
//         <SketchPicker
//           color={settings.secondaryColor}
//           onChange={(c) => handleColorChange("secondaryColor", c)}
//         />

//         <p>Logo</p>
//         <input type="file" accept="image/*" onChange={handleLogoUpload} />

//         <button onClick={handlePublish} style={{ marginTop: "20px" }}>
//           Publish
//         </button>
//       </div>

//       {/* Live Preview */}
//       <iframe
//         ref={iframeRef}
//         srcDoc={templateHtml}
//         style={{ flex: 1, height: "90vh", border: "1px solid #ccc" }}
//         title="Website Preview"
//         onLoad={applySettings}
//       />
//     </div>
//   );
// }


// import React, { useState } from "react";
// import { SketchPicker } from "react-color";

// export default function WebsiteEditor({ companyId }) {
//   const [templateHtml, setTemplateHtml] = useState(`
//     <div style="background-color: white; color: black; padding:20px;">
//       <h1 id="title">My Business</h1>
//       <p id="desc">Welcome to my website!</p>
//       <img id="logo" src="https://via.placeholder.com/200" alt="logo"/>
//     </div>
//   `);

//   const [color, setColor] = useState("#000000");

//   // Change color of text dynamically
//   const handleColorChange = (newColor) => {
//     setColor(newColor.hex);
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(templateHtml, "text/html");
//     doc.getElementById("title").style.color = newColor.hex;
//     setTemplateHtml(doc.body.innerHTML);
//   };

//   // Replace image
//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(templateHtml, "text/html");
//       doc.getElementById("logo").src = event.target.result;
//       setTemplateHtml(doc.body.innerHTML);
//     };
//     reader.readAsDataURL(file);
//   };

//   // Publish changes
//   const handlePublish = async () => {
//     await fetch(`/api/company/${companyId}/template`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ html: templateHtml }),
//     });
//     alert("Website published!");
//   };

//   return (
//     <div style={{ display: "flex", gap: "20px" }}>
//       {/* Editor Controls */}
//       <div style={{ width: "300px" }}>
//         <h3>Customization</h3>
//         <p>Pick a color for the title:</p>
//         <SketchPicker color={color} onChange={handleColorChange} />

//         <p>Upload logo:</p>
//         <input type="file" accept="image/*" onChange={handleImageChange} />

//         <button onClick={handlePublish} style={{ marginTop: "20px" }}>
//           Publish
//         </button>
//       </div>

//       {/* Live Preview */}
//       <div
//         style={{
//           border: "1px solid #ccc",
//           padding: "10px",
//           flexGrow: 1,
//           background: "#f9f9f9",
//         }}
//       >
//         <h3>Preview</h3>
//         <div
//           dangerouslySetInnerHTML={{ __html: templateHtml }}
//           style={{ minHeight: "400px" }}
//         />
//       </div>
//     </div>
//   );
// }
